import { render, staticRenderFns } from "./deleteMallMenu.vue?vue&type=template&id=4822f1b2&scoped=true"
import script from "./deleteMallMenu.vue?vue&type=script&lang=js"
export * from "./deleteMallMenu.vue?vue&type=script&lang=js"
import style0 from "./deleteMallMenu.vue?vue&type=style&index=0&id=4822f1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822f1b2",
  null
  
)

export default component.exports